// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"362": "__federation_expose_App","365": "__federation_expose_Insurance","503": "__federation_expose_Receivable",}[chunkId] + "." + {"362": "8362bd2f","365": "6038878c","503": "1ea17234",}[chunkId] + ".css"
}